import styled, { css } from 'styled-components'

import { preservePrintColor } from '../../../../utils/styles'

import footerHLine from '../../../../img/footer-hline.png'

export const FooterContainer = styled.footer<{ $printable?: boolean }>`
  position: relative;
  overflow: hidden;
  min-height: 475px;
  background-color: ${({ theme }) => theme.colors.component.backgroundDarkBlue};
  padding-top: 1rem;
  a {
    color: ${({ theme }) => theme.colors.grayscale.white};
    &:active {
      outline: 1px solid white !important;
      outline-offset: 5px !important;
      color: ${({ theme }) => theme.colors.grayscale.white};
    }
    &:focus {
      outline: 1px solid white !important;
      outline-offset: 5px !important;
    }
    &:hover {
      color: ${({ theme }) => theme.colors.grayscale.white};
    }
  }
  ${({ $printable }) =>
    $printable
      ? css`
          @media print {
            display: block;
            min-height: 0;
          }
          ${preservePrintColor}
        `
      : css`
          @media print {
            display: none;
          }
        `}
`

export const LogoAndSocialLinksContainer = styled.div`
  position: relative;
  background-image: url('${footerHLine}');
  background-repeat: repeat-x;
  width: 100%;
  padding: 1rem 15px 1rem 15px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  @media (min-width: 576px) {
    max-width: 540px;
  }
  @media (min-width: 768px) {
    max-width: 720px;
  }
  @media (min-width: 992px) {
    max-width: 960px;
  }
  @media (min-width: 1200px) {
    max-width: 1140px;
  }
`

export const Row = styled.div`
  margin: -15px;
  display: flex;
  flex-wrap: wrap;
`

export const Logo = styled.div`
  display: none;
  @media (min-width: 992px) {
    display: block;
    background-color: ${({ theme }) => theme.colors.component.backgroundDarkBlue};
    padding-right: 1rem;
    padding-top: 8px;
    img {
      display: block;
      height: 1.375rem;
    }
  }
`

export const SocialMediaLinks = styled.nav`
  margin-left: auto;
  margin-right: auto;
  @media (min-width: 992px) {
    margin-right: 0;
  }
`

export const LegalContainer = styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  display: block;
  color: ${({ theme }) => theme.colors.grayscale.white};
  overflow: hidden;
  position: relative;
  left: 0;
  top: 0;
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  font-size: 1.1875rem;
  text-transform: uppercase;
  box-sizing: border-box;
  @media (min-width: 576px) {
    max-width: 540px;
  }
  @media (min-width: 768px) {
    max-width: 720px;
  }
  @media (min-width: 992px) {
    max-width: 960px;
    font-size: 0.9375rem;
  }
  @media (min-width: 1200px) {
    max-width: 1140px;
  }
`

export const LegalBlock = styled.div`
  clear: both;
  text-align: center;
  font-size: 0.8125rem;
  margin: 50px 0 100px 0;
  text-transform: none;
`
